module.exports = __webpack_public_path__ + "static/media/sensor-fire.a4edcdc5.svg";